import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function SolidThumbsDownIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 2H6.3c-1.5 0-2.7 1-3 2.5l-1.3 7c-.3 1.6.8 3.2 2.4 3.5h5.1L9 16.4c-.8 2.1.3 4.5 2.4 5.3.5.2.9.3 1.4.3.4 0 .8-.2.9-.6l2.8-6.4H19c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3Zm1 10c0 .6-.4 1-1 1h-2V4h2c.6 0 1 .4 1 1v7Z"/>
  </SvgIcon>
}

export default SolidThumbsDownIcon
